"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontSize = exports.fontWeight = exports.fontFamily = exports.constants = exports.colors = undefined;

var _theme = require("./theme");

var _theme2 = _interopRequireDefault(_theme);

var _responsive = require("./responsive");

var _responsive2 = _interopRequireDefault(_responsive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createGetter = function createGetter(dict, base) {
  var getter = {};
  Object.keys(dict).forEach(function (item) {
    return getter[item] = function (props) {
      return base(props)[item];
    };
  });
  return getter;
};

var colors = exports.colors = createGetter(_theme2.default.colors, function (props) {
  return props.theme.colors;
});

var constants = exports.constants = createGetter(_theme2.default.constants, function (props) {
  return props.theme.constants;
});

var fontFamily = exports.fontFamily = function fontFamily(props) {
  return props.theme.fonts.family;
};

var fontWeight = exports.fontWeight = createGetter(_theme2.default.fonts.weight, function (props) {
  return props.theme.fonts.weight;
});

var fontSize = exports.fontSize = function fontSize(size) {
  return function (props) {
    return (0, _responsive2.default)("font-size", props.theme.fonts.size[size].xl, props.theme.fonts.size[size].lg, props.theme.fonts.size[size].md, props.theme.fonts.size[size].sm);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/buoy-theme/dist/helpers.js
// module id = 458
// module chunks = 168707334958949